// No platform cookies or authorization headers are forwarded to object storage.
// Use XHR only when callers need byte progress; ordinary uploads retain fetch.
export function sendUpload(
  url: string,
  body: FormData,
  signal: AbortSignal | null | undefined,
  onProgress: (percent: number) => void,
): Promise<{ ok: boolean }> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const abortError = () => new DOMException('上传已取消', 'AbortError');
    const abort = () => xhr.abort();
    const clean = () => signal?.removeEventListener('abort', abort);
    if (signal?.aborted) return reject(abortError());
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && event.total > 0)
        onProgress(Math.min(100, Math.round((event.loaded / event.total) * 100)));
    };
    xhr.onload = () => {
      clean();
      resolve({ ok: xhr.status >= 200 && xhr.status < 300 });
    };
    xhr.onerror = () => {
      clean();
      reject(new Error('文件直传失败，请检查网络后重试'));
    };
    xhr.onabort = () => {
      clean();
      reject(abortError());
    };
    xhr.open('POST', url);
    xhr.withCredentials = false;
    signal?.addEventListener('abort', abort, { once: true });
    onProgress(0);
    xhr.send(body);
  });
}
